__turbopack_context__.v({
  "root": "anchor-module__AjVG0W__root",
});
